import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));
const Preview = lazy(() => import('./Preview'));
const UpdateStatus = lazy(() => import('./UpdateStatus'));
const UpdateImage = lazy(() => import('./UpdateImage'));

export function TeamRoutes() {
  return (
    <Routes>
      <Route path={Pages.sports.team.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.sports.team.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.sports.team.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.sports.team.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.sports.team.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.sports.team.update.meta.path}
          element={(<Update />)}
        />
        <Route
          path={Pages.sports.team.preview.meta.path}
          element={(<Preview />)}
        />
        <Route
          path={Pages.sports.team.updateStatus.meta.path}
          element={(<UpdateStatus />)}
        />
        <Route
          path={Pages.sports.team.updateImage.meta.path}
          element={(<UpdateImage />)}
        />
      </Route>
    </Routes>
  );
}
